'use client';

import { type FC } from 'react';
import type { ClientEntryProps } from './ClientEntry.types';
import styles from './ClientEntry.module.css';
import { getClientEntryStatus, toggleClientEntry } from './ClientEntry.utils';
import { Flex, Heading, Text, Icon, Button, ButtonGroup } from '@/_components';

export const ClientEntry: FC<ClientEntryProps> = ({
  title,
  id,
  isDisabled,
  isLoading,
  description,
  icon,
  onEdit,
  onDelete,
}) => {
  const isSaved: boolean = getClientEntryStatus(id ?? -1);

  const onClientEntryEditClick = () => {
    !isSaved && toggleClientEntry(id ?? -1);

    return onEdit();
  };

  const onClientEntryDeleteClick = () => {
    isSaved && toggleClientEntry(id ?? -1);

    return onDelete();
  };

  return (
    <Flex gap={4} className={styles.clientEntry} isYCentered={true}>
      <Icon
        name={icon || 'home'}
        size={20}
        className={styles.clientEntry__icon}
      />
      <Flex isColumn={true} className={styles.clientEntry__content}>
        <Heading level={6}>{title || 'No Title'}</Heading>
        {description && <Text type="small">{description}</Text>}
      </Flex>
      <ButtonGroup>
        <div data-testid="client-entry-actions-edit-button">
          <Button
            intent="secondary"
            value="Enter Details"
            iconLeft="pencil"
            isPulsing={!isSaved && !isLoading}
            isDisabled={isDisabled || isLoading}
            onClick={onClientEntryEditClick}
            size="tiny"
          />
        </div>
        <Button
          intent="danger-secondary"
          value="Delete"
          iconLeft="trash"
          isDisabled={isDisabled || isLoading}
          isLoading={isLoading}
          isIconOnly={true}
          onClick={onClientEntryDeleteClick}
          size="tiny"
        />
      </ButtonGroup>
    </Flex>
  );
};
